<div class="contentnetword">
   <a class="spotify" href="https://open.spotify.com/episode/16mcib2YH8PwGhQpbkP6WQ?si=r9sniOdeSM-t2z6gnAWgkg&utm_source=copy-link"><img src="assets/iconsspotify.svg" alt=""></a> 
   <a class="youtube" href="https://www.youtube.com/channel/UCpphF_LbOkFbRjwta_QksHw"><img src="assets/iconsyoutube.svg" alt=""></a> 
   <a class="twitter" href="https://twitter.com/claudiapalacios?t=htQBrxBQPOidk0xWkw1riA&s=09"><img src="assets/iconstwitter.svg" alt=""></a> 
</div>
